export const EXPERIENCE_NAME = {
  /* Connect data center experience */
  CONNECT_DATA_CENTER: 'connectDataCenter',
  PREPARE_DATA_CENTER_CONNECT: 'connectDataCenter/prepare',
  CONSENT_DATA_CENTER_CONNECT: 'connectDataCenter/consent',
  PRODUCT_CONSENT_DATA_CENTER_CONNECT: 'connectDataCenter/productConsent',
  GENERATE_DATA_CENTER_CONNECT_SECURITY_KEY: 'connectDataCenter/generateSecurityKey',
  CONNECT_DATA_CENTER_SUMMARY: 'connectDataCenter/summary',
  COMPLETE_DATA_CENTER_CONNECT: 'connectDataCenter/complete',

  // Portfolio insights experience
  VIEW_PORTFOLIO_INSIGHTS_APPS: 'viewPortfolioInsightsApps',
  VIEW_PORTFOLIO_INSIGHTS_DETECTED_APPS: 'viewPortfolioInsightsDetectedApps',

  /* C2C migration experience */
  C2C_MIGRATION: 'c2cMigration',
  C2C_MIGRATION_HOW_IT_WORKS: 'c2cMigration/howItWorks',
  C2C_MIGRATION_SELECT_PRODUCTS: 'c2cMigration/selectProducts',
  C2C_MIGRATION_SELECT_SOURCE_DESTINATION: 'c2cMigration/selectSourceDestination',
  C2C_MIGRATION_SELECT_DATA: 'c2cMigration/selectData',
  C2C_MIGRATION_SELECT_GROUP_MEMBERSHIP: 'c2cMigration/selectGroupMembership',
  C2C_MIGRATION_ENTITY_CONFIGURATION: 'c2cMigration/entityConfiguration',
  C2C_MIGRATION_CHECK_DATA: 'c2cMigration/checkData',
  C2C_MIGRATION_VALIDATE_DATA: 'c2cMigration/validateData',
  C2C_MIGRATION_REVIEW_DATA: 'c2cMigration/reviewData',
  VIEW_C2C_MIGRATIONS_TABLE: 'viewC2CMigrationsTable',

  /* App assessment experience */
  DOWNLOAD_APP_ASSESSMENT_CSV: 'downloadAppAssessmentCsv',
  DOWNLOAD_CUSTOM_APP_ASSESSMENT_CSV: 'downloadCustomAppAssessmentCsv',
  APP_ASSESSMENT_VIEW_MARKETPLACE_APPS: 'viewAppAssessmentMarketplaceApps',
  APP_ASSESSMENT_VIEW_CUSTOM_APPS: 'viewAppAssessmentCustomApps',
  APP_ASSESSMENT_CHANGE_CLOUD_APP_DECISION: 'changeAppAssessmentCloudAppDecision',

  /* Sandbox experiences */
  CREATE_SANDBOX_MODAL: 'createSandboxModal',
  VIEW_SANDBOX_HOME_PAGE: 'viewSandboxHomePage',

  // Sandbox creation experience
  SANDBOX_CREATION: 'sandboxCreation',
  SANDBOX_CREATION_STEP_SELECT_PRODUCTION: 'sandboxCreation/stepSelectProduction',
  SANDBOX_CREATION_STEP_ADD_NAME: 'sandboxCreation/stepAddName',
  SANDBOX_CREATION_STEP_ADD_PRODUCT: 'sandboxCreation/stepAddProduct',

  SANDBOX_ADD_PRODUCTS_MODAL: 'sandboxAddProductsModal',
  SANDBOX_RESTORE_SITE_MODAL: 'sandboxRestoreSiteModal',
  SANDBOX_DEACTIVATE_SITE_MODAL: 'sandboxDeactivateSiteModal',
  DEACTIVATE_APP_SANDBOX: 'deactivateAppSandbox',

  /** Sandbox deployment experience */
  SANDBOX_DEPLOYMENT_DEPLOYMENT_LOG_LISTING: 'sandboxDeploymentLogListing',
  SANDBOX_DEPLOYMENT_DESTINATION_LISTING: 'sandboxDeploymentDestinationListing',
  SANDBOX_DEPLOYMENT_CREATE_DEPLOYMENT: 'sandboxDeploymentCreateDeployment',
  SANDBOX_DEPLOYMENT_START_VALIDATION: 'sandboxDeploymentStartValidation',
  SANDBOX_DEPLOYMENT_START_DEPLOYMENT: 'sandboxDeploymentStartDeployment',
  SANDBOX_DEPLOYMENT_DELETE_DEPLOYMENT: 'sandboxDeploymentDeleteDeployment',
  SANDBOX_DEPLOYMENT_RECONCILIATION_PROGRESS: 'sandboxDeploymentReconciliationProgress',
} as const;

export type ExperienceName = (typeof EXPERIENCE_NAME)[keyof typeof EXPERIENCE_NAME];

const experienceSet = new Set<string>(Object.values(EXPERIENCE_NAME));

export const isExperienceEvent = (event: string) => experienceSet.has(event);
